export class NoClientError extends Error
{
    type = "ClientException";
}
